import AddDocsToEmptyDataRoom from './AddDocsToEmptyDataRoom.component';

export default AddDocsToEmptyDataRoom;